import { useUTMContext } from "@src/context";
import { appendParamsToUrl } from "@src/utils/url-utils";
import { Navigate, type NavigateProps } from "@uhg-abyss/web/tools/reactRouterTools";
import type { FC } from "react";

export const UTMNavigate: FC<NavigateProps> = ({ to, replace, state }) => {
  const { utmTags } = useUTMContext();

  // Append UTM tags to the target URL
  const updatedTo =
    typeof to === "string"
      ? appendParamsToUrl(to, (utmTags as Record<string, string | undefined>) || {})
      : to;

  return <Navigate to={updatedTo} replace={replace} state={state} />;
};
